const Strings = {
  //app
  version: "v",
  versionNo: "1.0.0",
  appversion: "1",
  appname: "Bloopzy",
  appletter: "g",

  //other
  somethingWrong: "Something went wrong",
  noInternet: "No internet, Please try again!",
  homeDir: "/bloopzy",
};

export default Strings;
